import React from 'react';
import { useTheme } from 'styled-components';
import TimeRemainingText from '../../TimeRemainingText';
import { normalizeTimestamp, counterTypes } from 'shared/utils/TimestampManager';
import useFlickerTimer from '../hooks/useFlickerTimer';
import { TimerContainer, TimerIcon, TimeBar, ProgressBarTimerTextIconWrapper } from '../styledComponent';
import useTimeThreshold from 'shared/components/MissionsProgress/hooks/useTimeThreshold';

function BarTimerContainer({ missionsAssets, endTimestamp }) {
  const { MissionsProgress } = useTheme();
  const { isTenMinutesRemaining, isTwoHoursRemaining } = useTimeThreshold(endTimestamp);
  const { color } = useFlickerTimer({ isTwoHoursRemaining, isTenMinutesRemaining, intervalMs: 700 });
  return (
    <TimerContainer>
      <TimeBar
        src={
          isTwoHoursRemaining ? missionsAssets.TOP_BAR_TIMER_BACKGROUND_RED : missionsAssets.TOP_BAR_TIMER_BACKGROUND
        }
      />
      <ProgressBarTimerTextIconWrapper>
        <TimerIcon
          src={
            isTwoHoursRemaining ? missionsAssets.TOP_BAR_TIMER_CLOCK_ICON_RED : missionsAssets.TOP_BAR_TIMER_CLOCK_ICON
          }
        />
        <TimeRemainingText
          counterType={counterTypes.MISSION_PROGRERSS_BAR}
          style={{
            ...MissionsProgress.TimeText,
            color,
          }}
          until={normalizeTimestamp(endTimestamp)}
          inNavBar
        />
      </ProgressBarTimerTextIconWrapper>
    </TimerContainer>
  );
}

export default BarTimerContainer;

